import ScrollMagic from 'scrollmagic';
import { TweenMax, TimelineMax } from "gsap/all";
require('animation.gsap');


// hero parallax
const exhibitionHero = document.querySelector('.exhibition__hero');
let exhibitionController = null;
if( exhibitionHero ){
    exhibitionController = new ScrollMagic.Controller();
    // intro in
    new ScrollMagic.Scene({
        duration: '100%',
        triggerElement: '#hero',
        triggerHook: 0,
        offset: 0
    })
    .setTween(
        TweenMax.fromTo('.exhibition__hero-image', 1, {y:'-10%'},{y:'10%'})
    )
    .addTo(exhibitionController);
}